module.exports = __webpack_public_path__ + "img/社会综治-“屋畔”社区服务APP软件（ios版）V2.0.00c3cdb8.jpg";